import React,{FC, useEffect, useState} from 'react'
import {Grid,Typography,Theme, Button} from '@mui/material'
import { createStyles, makeStyles } from "@mui/styles";
import SearchDropdown from '../drDetails/components/SearchDropDown';
import useFilteredDoctors from 'hooks/useFilteredDoctors';
import useMatchedAddresses from 'hooks/useFilteredAddresses';
import { ErrorMessages } from 'utils/constants';
import { useStore } from 'store/StoreProvider';
import getFilteredData from 'hooks/useFiltereProviders';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useRoute } from 'hooks/RouteProvider';
import { useSession } from 'hooks/SessionProvider';
import useFilteredSchedules from 'hooks/useFilteredSchedules';
import { customRoutes } from 'utils/constants';
import { CallendarIcon } from 'assets/icons/base64Icons';
import useDrSchedules from 'hooks/useDrSchedules';

const useStyles = makeStyles((theme:Theme) =>
  createStyles({
    APTDetailsMain:{
      [theme.breakpoints.up('lg')]:{
        display:"flex",
        justifyContent:"space-between"
      }
    },
    DRDetailsMain:{
      backgroundColor:"#fff",
      marginTop:"15px !important",
     [theme.breakpoints.up('lg')]:{
      width:"50%"
     }
    },
      detailsHeaderMain:{
        [theme.breakpoints.up('lg')]:{
            width:"70%", 
        }, 
        
        [theme.breakpoints.down('lg')]:{
            width:"100%", 
        }, 
      },
      HeaderTitles:{
        color:"#2b2b2b!important",
        fontSize:"1rem !important",
        fontFamily: 'Open Sans !important', 
      },
      searchDropDownMargins:{
        marginTop:theme.spacing(1.5)
      },
      fixMargins:{
        marginTop:"17px"
      },
      filtersMian:{
       paddingTop:"25px !important"
      },

      continueButton:{
        backgroundColor:"#3D5A80 !important",
        borderRadius:"10px !important",
        borderColor:"#d6d6d6 !important",
        color:"#fff !important",
        '&:hover': {
        backgroundColor: '#fff !important',
        color:"#3D5A80 !important"
      },
        [theme.breakpoints.up('md')]:{
            width:"200px !important"
        },
        width:"150px !important"
    },
    icon: {
        position: 'absolute',
        right: '10px',
      },
      text: {
        flexGrow: 1,
        textAlign: 'center',
      },
      CallendarIcon:{
        [theme.breakpoints.up('lg')]:{
          display:"block",
          width:"45%",
          alignItems:"center",
        },
        [theme.breakpoints.down('lg')]:{
          display:"none"
        }
      }
  })
);

interface props{
  AppointmentTypes?:any;
  Addresses?:any;
  Providers?:any;
  Schedules?:any;
  AppointmentTypeDoctors?:any
}
const APTDetails:FC<props>=({AppointmentTypes,Addresses,Providers,Schedules,AppointmentTypeDoctors})=> {
  const classes = useStyles();
  const store=useStore();
  const data=store.getData();
  const { setActiveStep} = useSession();
  const [appointmentTypeId, setAppointmentTypeId] = useState<number | null | number[]>(store?.getSelectedDateTime()?.appointmentTypeID || 0);
  const [doctorId, setDoctorId] = useState<number | null | number[]>(store?.getDropDowns()?.providerID);
  const [locationId, setLocationId] = useState<number | null | number[]>(store?.getSelectedDateTime()?.addressID);
  const filteredDoctors = useFilteredDoctors(AppointmentTypeDoctors,Providers, appointmentTypeId);
  const filteredProviders = useDrSchedules(Schedules,locationId,Providers)
  const doctorsList = filteredProviders.length > 0 ? filteredProviders:filteredDoctors?.doctorList.length > 0 ? filteredDoctors?.doctorList : Providers;
  const filteredAddresses = useMatchedAddresses(doctorId || filteredDoctors?.doctorIds,Schedules,Addresses);
  const addressesList = filteredAddresses.length > 0 ? filteredAddresses:Addresses;
  const providerLabel = data?.widget_labels?.provider?.provider_label;
  const providerPlaceholder=data?.widget_labels?.provider?.placeholder;
  const[clearProvider,setClearProvider]=useState(false)
  const[validateLocation,setValidateLocation]=useState(false)
  const[validateApptType,setValidateApptType]=useState(false)
  const { navigate } = useRoute(); // Hook to navigate between routes
  const getAppointmentType = (id: number): any => {
    return data?.AppointmentTypes.find((appt: { id: number; }) => appt.id === id) || ""}
  const APTType=getAppointmentType(store?.getSelectedDateTime()?.appointmentTypeID)
  const onLocationChange=(id: number[] | number | null)=>{
   setLocationId(id)
   store.setSelectedDateTime({
    ...store?.getSelectedDateTime(),
    addressID: id,
})}

  const [isFoundSch, setIsFoundSch] = useState(true);
  const  preSelectedProvider =getFilteredData(data?.Providers,doctorId)
  const  preSelectedlocation =getFilteredData(data?.Addresses,locationId)
  const schedulesList=useFilteredSchedules(Schedules,locationId,doctorId || filteredDoctors?.doctorIds);
  const checkSchedule = () => schedulesList.length > 0;

  const onAppointmentTypeChange=(id: number | any)=>{
    if(appointmentTypeId !== id)
    {
      setDoctorId(null)
      setClearProvider(true)
    }
    setAppointmentTypeId(id); 
    store.setSelectedDateTime({
        ...store?.getSelectedDateTime(),
        appointmentTypeID: id,
    })
  }

  useEffect(()=>{
    setActiveStep(0)
  },[])

  useEffect(()=>{
    setIsFoundSch(!(locationId && appointmentTypeId && !checkSchedule()));
  },[locationId,appointmentTypeId,checkSchedule])

  const onDoctorChange=(ids: number[] | number | null)=>{
    setDoctorId(ids)
    store.setDropDowns({...store.getDropDowns(),providerID:ids})
  }

  const moveNext=()=>{
    if(locationId && appointmentTypeId) navigate(customRoutes.DRDetails)
    if(!locationId) setValidateLocation(true)
    if(!appointmentTypeId) setValidateApptType(true)
  }

  return (
   <Grid  sx={{height: "100%", overflow: "hidden",marginTop:{lg:"50px",xs:"20px"},marginBottom:{lg:"50px",xs:"20px"}}} className={classes.APTDetailsMain}>
      <Grid className={classes.DRDetailsMain}>
          <Grid sx={{width:"100%",display:"flex"}}>
              <Grid className={classes.detailsHeaderMain} >
                  <Grid   className={classes.filtersMian} >
                    <Grid>
                      <Typography variant='h1' className={classes.HeaderTitles}>Appointment Type *</Typography>
                    </Grid>
                    <Grid className={classes.searchDropDownMargins}>
                        <SearchDropdown keyValue={["name"]} dropDownParms={AppointmentTypes||[]} placeholder={"Select Reason"} onChange={onAppointmentTypeChange} useValidation={true} ErrMultiple={ErrorMessages.AppTypeMultiple} ErrSingle={ErrorMessages.AppTypeSingle} selectedOption={APTType} isValidation={validateApptType}></SearchDropdown>
                    </Grid>
                  </Grid>
                  <Grid  className={classes.filtersMian} >
                    <Grid>
                      <Typography variant='h1' className={classes.HeaderTitles}>Location *</Typography>
                    </Grid>
                    <Grid className={classes.searchDropDownMargins}>
                        <SearchDropdown keyValue={["name"]} dropDownParms={addressesList||[]} placeholder={"Select location"} onChange={onLocationChange} selectedOption={preSelectedlocation} isValidation={validateLocation} ErrSingle={ErrorMessages.locationSingle} useValidation={true} ></SearchDropdown>
                    </Grid>
                  </Grid>
                  <Grid  className={classes.filtersMian} >
                    <Grid>
                      <Typography variant='h1' className={classes.HeaderTitles}>{providerLabel || "Provider"}</Typography>
                    </Grid>
                    <Grid className={classes.searchDropDownMargins}>
                        <SearchDropdown keyValue={['first_name', 'last_name']} dropDownParms={doctorsList||[]} placeholder={providerPlaceholder || "Select Provider"} onChange={onDoctorChange} isClearSelection={clearProvider} setIsClearSelection={setClearProvider} selectedOption={preSelectedProvider}></SearchDropdown>
                    </Grid>
                  </Grid>

                  <Grid sx={{marginTop:"10px",height:"20px"}}>
                    {!isFoundSch && schedulesList.length == 0 &&
                      <Grid >
                        <Typography sx={{color:"red",fontWeight:"550"}}>{ErrorMessages.noSchedules}</Typography>
                        </Grid>
                      }
                  </Grid>

                  <Grid sx={{textAlign:"right",marginTop:{lg:"50px !important",xs:"30px !important"}}}>
                    <Button variant='outlined' className={classes.continueButton} sx={{textTransform: "none", backgroundColor:`${!isFoundSch && "grey !important"}`}} onClick={moveNext} disabled={!isFoundSch && true} >
                    <span className={classes.text}>Continue</span>
                    <ArrowForwardIcon className={classes.icon} /></Button>
                </Grid>
              </Grid>
          </Grid>
      </Grid>

      <Grid className={classes.CallendarIcon}>
        <img src={CallendarIcon} alt="" style={{width:"75%"}} />
      </Grid>
   </Grid>
  )
}

export default APTDetails